import React from "react";
import Link from "next/link";

const UnderstandingRequirementsHelp = () => {
    return (
        <div className="space-y-4">
            <h2 className="text-xl font-semibold">Understanding Your Options For Care</h2>
            <p>When choosing a senior living community, consider these key factors:</p>
            <div className="grid gap-4">
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Key Considerations</h3>
                    <div className="space-y-3 text-gray-800 mt-2">
                        <div>
                            <h4 className="font-bold">Type Of Care</h4>
                            <p>
                                Determine whether you need independent living, assisted
                                living, or memory care.
                            </p>
                        </div>
                        <div>
                            <h4 className="font-bold">Location</h4>
                            <p>
                                Consider proximity to family, medical facilities, and
                                preferred amenities.
                            </p>
                        </div>
                        <div>
                            <h4 className="font-bold">Base Rate</h4>
                            <p>
                                Factor in monthly base rate, care services, and other
                                potential expenses.
                            </p>
                        </div>
                        <div>
                            <h4 className="font-bold">Lifestyle Preferences</h4>
                            <p>
                                Think about desired activities, social opportunities, and
                                community culture.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Contact Us</h3>
                    <p className="text-gray-800 mt-1">
                        Visit our{" "}
                        <Link
                            href="/contact-us"
                            className="text-primary-600 hover:text-primary-800 underline font-bold"
                        >
                            contact page
                        </Link>{" "}
                        and an advisor will contact you.
                    </p>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Call Us</h3>
                    <p className="text-gray-800 mt-1">
                        Reach us at{" "}
                        <a
                            href="tel:6127877533"
                            className="text-primary-600 hover:text-primary-800 font-bold"
                        >
                            (612) PURPLE-3
                        </a>{" "}
                        or{" "}
                        <a
                            href="tel:6127877533"
                            className="text-primary-600 hover:text-primary-800 font-bold"
                        >
                            (612) 787-7533
                        </a>
                    </p>
                </div>
            </div>
            <p className="text-sm text-gray-500 mt-4">
                Our team is available during business hours to help you evaluate your
                requirements.
            </p>
        </div>
    );
};

export default UnderstandingRequirementsHelp;
